export default class ScrollSpy {
  constructor (container, elementsToSpy, observerOptions) {
    var _this12 = this;

    this.container = container;
    this.targets = [];
    this.targetIndices = {};
    this.indicesInViewPort = [];

    this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), observerOptions);

    elementsToSpy.forEach(function (elementToSpy, index) {
      _this12.targets.push(elementToSpy);
      _this12.targetIndices[elementToSpy.id] = index;
      _this12.observer.observe(elementToSpy);
    });
  }

  destroy() {
    this.observer.disconnect();
  }

  /**
   * Called whenever there is a change of visibility
   */

  _onIntersectionChange(changes) {
    var oldTargetIndex = this.indicesInViewPort[0] || 0;

    for (var i = changes.length - 1; i >= 0; i--) {
      this._updateIndicesInViewPort(changes[i], oldTargetIndex);
    }

    // Firefox generates duplicates so make sure to remove
    this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });

    if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
      return;
    }

    var event = new CustomEvent('scrollspy:target:changed', {
      detail: {
        newTarget: this.targets[this.indicesInViewPort[0]],
        oldTarget: this.targets[oldTargetIndex]
      }
    });

    this.container.dispatchEvent(event);
  }

  /**
   * Update indices visible in the view port
   */

  _updateIndicesInViewPort(change, oldTargetIndex) {
    var index = this.targetIndices[change.target.id];

    if (change.intersectionRatio === 0) {
      var indexInViewPort = this.indicesInViewPort.indexOf(index);

      if (indexInViewPort !== -1) {
        this.indicesInViewPort.splice(indexInViewPort, 1);
      }
    } else {
      if (index < oldTargetIndex) {
        this.indicesInViewPort.unshift(index);
      } else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
        this.indicesInViewPort.push(index);
      } else {
        this.indicesInViewPort.push(index);
        this.indicesInViewPort.sort();
      }
    }
  }
}